export default "__VITE_ASSET__BKF2jcr$__"